import { UnorderedList, ListItem, FormHelperText } from '@chakra-ui/react';

const TermsList = () => (
  <FormHelperText fontSize="xs">
    <UnorderedList spacing={1}>
      <ListItem>
        You must be at least 13 years old. If you&apos;re under 18 years old, you need to have a
        parent&apos;s or guardian&apos;s permission to participate!
      </ListItem>
      <ListItem>Including your friends? Make sure they are cool with it and are over 18.</ListItem>
      <ListItem>
        If you didn&apos;t shoot the video, you must have permission from the person who shot the
        video to submit it.
      </ListItem>
      <ListItem>
        Keep it clean - you shouldn&apos;t include any alcohol or vulgar language in your entries.
      </ListItem>
      <ListItem>
        Don&apos;t submit materials that are embarrassing or defamatory to anyone.
      </ListItem>
    </UnorderedList>
  </FormHelperText>
);

export default TermsList;
